import { render } from "./LayoutsAuthMobileHeaderWellLabo.vue?vue&type=template&id=ad0b46b0&scoped=true&ts=true"
import script from "./LayoutsAuthMobileHeaderWellLabo.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthMobileHeaderWellLabo.vue?vue&type=script&lang=ts"

import "./LayoutsAuthMobileHeaderWellLabo.vue?vue&type=style&index=0&id=ad0b46b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0b46b0"]])

export default __exports__